//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';

import ScienceAndResearchHeroOR4 from './ScienceAndResearchHeroOR4';

const ScienceAndResearchHero = (): JSX.Element => {
  return (
    <div data-cy="science-and-research-hero">
      <InverseHeader enter>
        <ScienceAndResearchHeroOR4 />
      </InverseHeader>
    </div>
  );
};

export default ScienceAndResearchHero;
